let apiUrl = '/api/bccapi/'
let bpiUrl = '/api/accapi/'

let API = {
  // 注册发送验证码
  VerificationCode: apiUrl + 'userGame/sendCaptcha',
  // 注册验证验证码
  InspectVerificationCode: apiUrl + 'userGame/verfiyCaptcha',
  // 注册发送手机验证码
  sendCaptchasms: apiUrl + 'userGame/sendCaptchasms',
  // 验证手机验证码接口
  verfiyCaptchasms: apiUrl + 'userGame/verfiyCaptchasms',
  // 注册
  RegisterReg: apiUrl + 'userGame/reg',
  // 登入
  Login: apiUrl + 'userGame/login',
  // Google登入
  GgLogin: apiUrl + 'extUser/gpLogin',
  // fb登入
  fbLogin: apiUrl + 'extUser/fbLogin',
  // 忘记密码发送邮件
  ForgetPwd: apiUrl + 'userGame/forgetPwd',
  //更新密码
  updatePwd: apiUrl + 'userGame/updatePwd',
  // 查询全部游戏
  GameList: bpiUrl + 'solaplayApp/getAllGame',
  // 查询最近充值游戏
  LastGame: bpiUrl + 'solaplayApp/depositQuery',
  // 获取文章
  GetContentList: bpiUrl + 'solaplayApp/getContentList',
  // 获取文章详情
  GetContentDetail: bpiUrl + 'solaplayApp/getContentDetail',
  // 获取轮播图列表
  GetBanner: bpiUrl + 'solaplayApp/getBanner',
  // 获取轮播图详情
  GetBannerDetail: bpiUrl + 'solaplayApp/getBannerDetail',
  // 获取产品页详情
  GetProductDetail: bpiUrl + 'solaplayApp/getProductDetail'
}
export default {
  API: API
}



// WEBPACK FOOTER //
// ./src/api/api.js